import React from 'react';
import { Link, H2 } from '../components/utils.js';


class ProspectiveMember extends React.Component {
  render() {
    return (
      <div>
        <div className="container py-8 pt-md-10">
          <div className="row">
            <div className="col-12">
              <section>
                <H2>How to Apply</H2>
                <dl className="row">
                  <dt className="col-lg-3">
                    Prospective PhD students:
                  </dt>
                  <dd className="col-lg-9">
                    <p>
                      Apply to the <Link href="https://www.stat.ubc.ca/graduate-admissions">UBC stats department</Link>. Mention me as a potential advisor.
                    </p>
                    <p>
                      You can alternatively apply to the <Link href="https://www.cs.ubc.ca/students/grad/admissions">UBC CS department</Link> if you would prefer to take CS courses/fulfil CS degree requirements.
                      Again, mention me as a potential advisor.
                      (I can admit and advise students through either department.)
                    </p>
                    <p>
                      If you are coming directly from undergrad (without a MSc), I will only consider your application if you have a sufficient research background and a clear vision.
                      You will have to apply for the "PhD-track MSc" program in either CS or Stats.
                      It is, for all intents and purposes, the same as applying directly to a PhD program in the US.
                    </p>
                  </dd>
                  <dt className="col-lg-3">
                    Prospective MSc students:
                  </dt>
                  <dd className="col-lg-9">
                    <p>
                      Apply to the <Link href="https://www.stat.ubc.ca/graduate-admissions">UBC stats department</Link>.
                      MSc students are admitted into the program rather than directly into the lab
                      (with the exeception of PhD-track MSc students; see above).
                      If you are admitted, then we can assess your fit during your first year at UBC.
                    </p>
                    <p>
                      I do not supervise MSc students in the CS department (again, with the exception of PhD-track MSc students; see above).
                    </p>
                  </dd>
                  <dt className="col-lg-3 mt-3">
                    Prospective postdocs:
                  </dt>
                  <dd className="col-lg-9 mt-lg-3">
                    Applications go through <Link href="https://vectorinstitute.bamboohr.com/jobs/view.php?id=136">Vector's post-doctoral fellowship.</Link> Mention me as a potential advisor.
                  </dd>
                </dl>
              </section>
              <section className="mt-5">
                <H2>Should I Contact You?</H2>
                <p>
                  You may email me directly to start a conversation and let me know that you are interested.
                  However, I will only respond if I think you are a good candidate, so you'll need to give me enough information to work with.
                </p>
                <p>
                  Tell me about your prior research experience and your current research interests.
                  Most importantly, <em>please let me know why you want to specificity work with me</em>.
                  I prefer substance over flattery.
                  If you say "I wish to join your esteemed lab to work on important problems in machine learning," then I will likely not respond.
                  If you say "I am interested in uncertainty quantification for neural networks. I admire your recent studies of ensemble methods, and I have a few follow up research ideas..." then I'll be interested in following up with you!
                </p>
                <p>
                  You should include "[Potential Pleiss lab member]" in your email subject. (That will let me know that you've read the information on this page!)
                </p>
              </section>
              <section className="mt-5">
                <H2>Are There Internship, Undergraduate, or Visiting Student Opportunities?</H2>
                <p>
                  I occasionally hire 4-month research interns through <Link href="https://vectorinstitute.ai/research-talent/students/ai-research-internships/">Vector's internship program,</Link> though I generally only consider graduate students who list me as their top-choice supervisor.
                </p>
                <p>
                  I sometimes supervise undergraduates through UBC's internal programs.
                  Look for postings in the winter.
                </p>
                <p>
                  It doesn't hurt to contact me about other opportunities, but again I won't respond unless you pique my interest.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default ProspectiveMember;
